export default "__VITE_PUBLIC_ASSET__a356b8f3__"